<template>
    <v-card>
        <v-card-title>
            <span class="text-h5">Buddy Insurance</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('modal-close')"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-container class="p-4">
            <p>
                By checking the box and purchasing Buddy Accident insurance, I acknowledge
                that I have read, understand and agree to the
                <a target="_blank" style="text-decoration:underline; color: blue;" href="https://buddyinsurance.com/partners/policy-info/">
                    <strong>important Disclosures, policy terms, conditions and exclusions.</strong>
                </a>
            </p>
        </v-container>
    </v-card>
</template>

<script>
export default {
    name: "DialogBuddyInsurance"
}
</script>

<style scoped>

</style>
